"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GrpcWebError = exports.GrpcWebImpl = exports.WebLoginServiceWebReactivateAccountDesc = exports.WebLoginServiceWebRequestLoginChallengeDesc = exports.WebLoginServiceWebLoginDesc = exports.WebLoginServiceDesc = exports.WebLoginServiceClientImpl = void 0;
/* eslint-disable */
const grpc_web_1 = require("@improbable-eng/grpc-web");
const web_login_1 = require("./web_login");
const web_request_login_challenge_1 = require("./web_request_login_challenge");
const web_reactivate_account_1 = require("./web_reactivate_account");
const browser_headers_1 = require("browser-headers");
class WebLoginServiceClientImpl {
    rpc;
    constructor(rpc) {
        this.rpc = rpc;
        this.WebLogin = this.WebLogin.bind(this);
        this.WebRequestLoginChallenge = this.WebRequestLoginChallenge.bind(this);
        this.WebReactivateAccount = this.WebReactivateAccount.bind(this);
    }
    WebLogin(request, metadata) {
        return this.rpc.unary(exports.WebLoginServiceWebLoginDesc, web_login_1.WebLoginRequest.fromPartial(request), metadata);
    }
    WebRequestLoginChallenge(request, metadata) {
        return this.rpc.unary(exports.WebLoginServiceWebRequestLoginChallengeDesc, web_request_login_challenge_1.WebRequestLoginChallengeRequest.fromPartial(request), metadata);
    }
    WebReactivateAccount(request, metadata) {
        return this.rpc.unary(exports.WebLoginServiceWebReactivateAccountDesc, web_reactivate_account_1.WebReactivateAccountRequest.fromPartial(request), metadata);
    }
}
exports.WebLoginServiceClientImpl = WebLoginServiceClientImpl;
exports.WebLoginServiceDesc = {
    serviceName: "snapchat.janus.api.WebLoginService",
};
exports.WebLoginServiceWebLoginDesc = {
    methodName: "WebLogin",
    service: exports.WebLoginServiceDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return web_login_1.WebLoginRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return {
                ...web_login_1.WebLoginResponse.decode(data),
                toObject() {
                    return this;
                },
            };
        },
    },
};
exports.WebLoginServiceWebRequestLoginChallengeDesc = {
    methodName: "WebRequestLoginChallenge",
    service: exports.WebLoginServiceDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return web_request_login_challenge_1.WebRequestLoginChallengeRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return {
                ...web_request_login_challenge_1.WebRequestLoginChallengeResponse.decode(data),
                toObject() {
                    return this;
                },
            };
        },
    },
};
exports.WebLoginServiceWebReactivateAccountDesc = {
    methodName: "WebReactivateAccount",
    service: exports.WebLoginServiceDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return web_reactivate_account_1.WebReactivateAccountRequest.encode(this).finish();
        },
    },
    responseType: {
        deserializeBinary(data) {
            return {
                ...web_reactivate_account_1.WebReactivateAccountResponse.decode(data),
                toObject() {
                    return this;
                },
            };
        },
    },
};
class GrpcWebImpl {
    host;
    options;
    constructor(host, options) {
        this.host = host;
        this.options = options;
    }
    unary(methodDesc, _request, metadata) {
        const request = { ..._request, ...methodDesc.requestType };
        const maybeCombinedMetadata = metadata && this.options.metadata
            ? new browser_headers_1.BrowserHeaders({
                ...this.options?.metadata.headersMap,
                ...metadata?.headersMap,
            })
            : metadata || this.options.metadata;
        return new Promise((resolve, reject) => {
            grpc_web_1.grpc.unary(methodDesc, {
                request,
                host: this.host,
                metadata: maybeCombinedMetadata,
                transport: this.options.transport,
                debug: this.options.debug,
                onEnd: function (response) {
                    if (response.status === grpc_web_1.grpc.Code.OK) {
                        resolve(response.message);
                    }
                    else {
                        const err = new GrpcWebError(response.statusMessage, response.status, response.trailers);
                        reject(err);
                    }
                },
            });
        });
    }
}
exports.GrpcWebImpl = GrpcWebImpl;
class GrpcWebError extends Error {
    code;
    metadata;
    constructor(message, code, metadata) {
        super(message);
        this.code = code;
        this.metadata = metadata;
    }
}
exports.GrpcWebError = GrpcWebError;
//# sourceMappingURL=web_login_service.js.map